module.exports = __webpack_public_path__ + "img/4-3.e6ad2415.png";